<div class="bgColor">
    <h1 class="errorHeader">Something went wrong</h1>
    <p class="message">Your payment did not go through. We are redirecting you back to the register page. <br><br>
    For more information, please contact support.</p>
    
</div>


<div *ngIf="loading" class="spinner-wrapper">
    <mat-spinner [diameter]="50" mode="indeterminate"></mat-spinner>
  </div>